// // frontend/src/DataView.js
// import React, { useEffect, useState, useCallback, useRef } from "react";
// import axios from 'axios'; // Import axios
// import Modal from 'react-modal';
// import './App.css'; // Reuse common styles

// import FilterModal from './FilterModal.js'; // Import FilterModal component

// // Ensure Modal is configured
// Modal.setAppElement('#root'); // Or your app's root element ID

// // --- Column Selection Modal ---
// // (No changes needed in this component)
// const ColumnSelectionModal = ({ visible, onClose, onToggleColumn, visibleColumns = [], allColumns = [] }) => {
//     const modalStyle = {
//         content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', maxWidth: '400px', maxHeight: '70vh', overflow: 'auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' },
//         overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)', zIndex: 1001 },
//     };
//     return (
//         <Modal isOpen={visible} onRequestClose={onClose} style={modalStyle} contentLabel="Select Columns">
//             <div className="column-select-modal">
//                 <h3>Select Columns to Display</h3>
//                 <div className="column-list">
//                     {allColumns.map(col => (
//                         <div key={col} className="column-item">
//                             <label>
//                                 <input
//                                     type="checkbox"
//                                     checked={visibleColumns.includes(col)}
//                                     onChange={() => onToggleColumn(col)}
//                                 />
//                                 {col}
//                             </label>
//                         </div>
//                     ))}
//                 </div>
//                  <div className="modal-button-group" style={{marginTop: '20px'}}>
//                     <button onClick={onClose} className="modal-close-button">Close</button>
//                 </div>
//             </div>
//         </Modal>
//     );
// };

// // --- File Detail Modal (with Tabs and Statement Generation) ---
// const FileDetailModal = ({ isOpen, onClose, fileData, allColumns = [] }) => {
//     const [activeTab, setActiveTab] = useState('details');
//     const [selectedKnColumn, setSelectedKnColumn] = useState('');
//     const [statements, setStatements] = useState([]);
//     const [knColumns, setKnColumns] = useState([]);
//     const [parsingError, setParsingError] = useState('');

//     // Effect to reset state and identify 'kn' columns when fileData changes
//     useEffect(() => {
//         // This effect runs ONLY when the modal opens with a new file (fileData changes)
//         // or when the available columns change (less common within the modal).
//         if (fileData) {
//             const availableKnCols = allColumns.filter(col => col.startsWith('kn') && fileData[col] != null);
//             setKnColumns(availableKnCols);
//             if (availableKnCols.length > 0) {
//                 if (!selectedKnColumn || !availableKnCols.includes(selectedKnColumn)) {
//                     setSelectedKnColumn(availableKnCols[0]);
//                 }
//             } else {
//                 setSelectedKnColumn('');
//             }
//             // Reset tab to 'details' when a NEW file is opened. This is intended.
//             setActiveTab('details');
//             setParsingError('');
//         } else {
//             // Reset state when modal closes or fileData is null
//             setKnColumns([]);
//             setSelectedKnColumn('');
//             setStatements([]);
//             setParsingError('');
//             setActiveTab('details');
//         }
//         // This effect does NOT depend on `selectedKnColumn` changing *within* the modal,
//         // so changing the dropdown in the Statements tab will NOT trigger this reset.
//     }, [fileData, allColumns, selectedKnColumn]); // selectedKnColumn added only to handle initial setting correctly

//     // --- Statement Generation Logic ---
//     const generateStatementsFromKnData = useCallback((knDataRaw) => {
//         setParsingError('');
//         if (!knDataRaw) return [];

//         let jsonData = null;
//         let generatedStatements = [];

//         try {
//             if (typeof knDataRaw === 'string') {
//                 jsonData = JSON.parse(knDataRaw);
//             } else if (typeof knDataRaw === 'object' && knDataRaw !== null) {
//                 jsonData = knDataRaw;
//             } else {
//                  throw new Error("Data is not a valid JSON string or object.");
//             }
//         } catch (error) {
//             console.error(`Error parsing ${selectedKnColumn}:`, error);
//             setParsingError(`Error parsing data in '${selectedKnColumn}'. Is it valid JSON?`);
//             return [];
//         }

//         if (!Array.isArray(jsonData)) {
//              if (typeof jsonData === 'object' && jsonData !== null) {
//                  jsonData = [jsonData];
//              } else {
//                 console.warn(`Parsed data in '${selectedKnColumn}' is not an array or object.`);
//                 setParsingError(`Data in '${selectedKnColumn}' is not in the expected format (array of objects).`);
//                 return [];
//              }
//         }

//         jsonData.forEach((item, index) => {
//             if (item && typeof item === 'object' && item.node_1 && item.node_2 && item.edge) {
//                 const n1 = String(item.node_1).trim();
//                 const n2 = String(item.node_2).trim();
//                 const edge = String(item.edge).trim();
//                 if (n1 && n2 && edge) {
//                     generatedStatements.push({ id: `${selectedKnColumn}-${index}`, text: `${n1} ${edge} ${n2}` });
//                 } else {
//                     console.warn(`Skipping statement at index ${index} in '${selectedKnColumn}' due to empty node/edge.`);
//                 }
//             } else {
//                  console.warn(`Skipping item at index ${index} in '${selectedKnColumn}' due to invalid structure.`);
//             }
//         });

//         return generatedStatements;
//     }, [selectedKnColumn]);

//     // Effect to generate statements when selectedKnColumn or fileData changes
//     useEffect(() => {
//         // This effect specifically handles regenerating statements when the selected source changes.
//         // It depends on `selectedKnColumn` and calls `generateStatementsFromKnData`.
//         // Crucially, it ONLY updates the `statements` state and `parsingError` state.
//         // It does NOT change the `activeTab`. This ensures the view stays on the
//         // Statements tab and the list refreshes.
//         if (fileData && selectedKnColumn && knColumns.includes(selectedKnColumn)) {
//             const newStatements = generateStatementsFromKnData(fileData[selectedKnColumn]);
//             setStatements(newStatements);
//         } else {
//             setStatements([]);
//         }
//     }, [fileData, selectedKnColumn, knColumns, generateStatementsFromKnData]); // Correct dependencies

//     if (!fileData) return null;

//     // Define columns for the 'Details' tab (excluding 'kn_' columns)
//     const detailColumns = allColumns.filter(col => !col.startsWith('kn'));

//     // Modal styles and layout structure
//     const modalStyle = {
//         content: {
//             top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%',
//             transform: 'translate(-50%, -50%)', width: '75%', maxWidth: '1000px', maxHeight: '85vh',
//             padding: '0', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff',
//             display: 'flex', flexDirection: 'column',
//         },
//         overlay: { backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 1050 },
//     };
//     const headerStyle = {
//         padding: '15px 20px', borderBottom: '1px solid #eee', fontWeight: 'bold', fontSize: '1.1em',
//         flexShrink: 0, backgroundColor: '#f8f9fa',
//         display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//     };
//      const tabContainerStyle = {
//          display: 'flex', borderBottom: '1px solid #ccc', padding: '0 20px',
//          flexShrink: 0, backgroundColor: '#f8f9fa',
//      };
//     const tabButtonStyle = (tabName) => ({
//         padding: '10px 15px',
//         border: 'none',
//         borderBottom: activeTab === tabName ? '3px solid var(--primary-color)' : '3px solid transparent',
//         cursor: 'pointer',
//         backgroundColor: activeTab === tabName ? '#fff' : 'transparent',
//         color: activeTab === tabName ? 'var(--primary-color)' : 'var(--secondary-color)',
//         fontWeight: activeTab === tabName ? '600' : '500',
//         fontSize: '0.95em',
//         marginRight: '5px',
//         marginBottom: '-1px',
//     });
//     const contentStyle = {
//         padding: '20px',
//         overflowY: 'auto', // This makes the content area scrollable
//         flexGrow: 1,
//         minHeight: '0',
//     };
//     const footerStyle = {
//         padding: '10px 20px', borderTop: '1px solid #eee', textAlign: 'right',
//         flexShrink: 0, backgroundColor: '#f8f9fa',
//     };
//      const statementListStyle = {
//          listStyle: 'decimal',
//          paddingLeft: '25px',
//          margin: '10px 0',
//          maxHeight: '50vh',
//          overflowY: 'auto',
//          border: '1px solid #eee',
//          borderRadius: '4px',
//          padding: '10px 15px 10px 30px',
//          background: '#fdfdfd',
//      };
//      const statementItemStyle = {
//          marginBottom: '8px',
//          paddingBottom: '8px',
//          borderBottom: '1px dotted #eee',
//          fontSize: '0.9em',
//          lineHeight: '1.4',
//      };

//     return (
//         <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyle} contentLabel="File Details" ariaHideApp={false}>
//             <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//                 {/* Header */}
//                 <div className="modal-header" style={headerStyle}>
//                     <span>Details for: {fileData.file_name || `ID: ${fileData.id}`}</span>
//                     <button onClick={onClose} className="modal-close-button" style={{padding: '5px 10px', fontSize: '0.9em'}}>Close</button>
//                 </div>

//                 {/* Tab Buttons */}
//                 <div className="modal-tabs" style={tabContainerStyle}>
//                     <button style={tabButtonStyle('details')} onClick={() => setActiveTab('details')}>
//                         Details
//                     </button>
//                     {knColumns.length > 0 && (
//                         <button style={tabButtonStyle('statements')} onClick={() => setActiveTab('statements')}>
//                             Statements
//                         </button>
//                     )}
//                 </div>

//                 {/* Tab Content (Scrollable Area) */}
//                 <div className="modal-content" style={contentStyle}>
//                     {/* Details Tab */}
//                     {activeTab === 'details' && (
//                         <div className="details-grid">
//                              {/* This grid renders ALL non-'kn' columns.
//                                  Scrolling is handled by the parent 'modal-content' div's CSS.
//                                  The added media query in App.css makes this grid responsive.
//                              */}
//                             {detailColumns.map(col => (
//                                 <React.Fragment key={col}>
//                                     <div className="detail-label">{col}:</div>
//                                     <div className="detail-value">
//                                         {typeof fileData[col] === 'object' && fileData[col] !== null ? (
//                                             <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0, fontSize: '0.9em' }}>{JSON.stringify(fileData[col], null, 2) || 'Not available'}</pre>
//                                         ) : (
//                                             <div style={{ whiteSpace: "pre-wrap", wordBreak: 'break-all' }}>{String(fileData[col] ?? '') || 'Not available'}</div>
//                                         )}
//                                     </div>
//                                 </React.Fragment>
//                             ))}
//                              {detailColumns.length === 0 && <p>No non-'kn' columns to display.</p>}
//                         </div>
//                     )}

//                     {/* Statements Tab */}
//                     {activeTab === 'statements' && knColumns.length > 0 && (
//                         <div className="statements-tab">
//                             <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
//                                 <label htmlFor="knColumnSelect" style={{ fontWeight: '600', fontSize: '0.9em' }}>Select Source:</label>
//                                 <select
//                                     id="knColumnSelect"
//                                     value={selectedKnColumn}
//                                     // Changing this updates selectedKnColumn state, triggering statement regeneration
//                                     // It does NOT change activeTab state.
//                                     onChange={(e) => setSelectedKnColumn(e.target.value)}
//                                     style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.9em' }}
//                                 >
//                                     {knColumns.map(col => (
//                                         <option key={col} value={col}>{col}</option>
//                                     ))}
//                                 </select>
//                             </div>

//                             {parsingError && <div className="error" style={{ fontSize: '0.9em', padding: '8px', marginBottom: '10px' }}>{parsingError}</div>}

//                             {statements.length > 0 ? (
//                                 <ol style={statementListStyle}>
//                                     {statements.map((stmt, index) => (
//                                         <li key={stmt.id || index} style={statementItemStyle}>
//                                             {stmt.text}
//                                         </li>
//                                     ))}
//                                 </ol>
//                             ) : (
//                                 !parsingError && <p style={{ fontStyle: 'italic', color: '#666', fontSize: '0.9em' }}>No statements found or generated for '{selectedKnColumn}'.</p>
//                             )}
//                              <p style={{ fontSize: '0.85em', color: '#777', marginTop: '10px' }}>
//                                  Displaying {statements.length} statements from column: <strong>{selectedKnColumn}</strong>
//                              </p>
//                         </div>
//                     )}
//                      {activeTab === 'statements' && knColumns.length === 0 && (
//                         <p style={{ fontStyle: 'italic', color: '#666', fontSize: '0.9em' }}>No columns starting with 'kn' found in this file's data.</p>
//                      )}
//                 </div>
//             </div>
//         </Modal>
//     );
// };
// // --- End File Detail Modal ---

// // --- DataView Component ---
// // (No changes needed in the main DataView component logic itself for this request)
// const DataView = ({ directories = [], handleLogout }) => {
//     // --- State (No changes) ---
//     const [selectedDirectory, setSelectedDirectory] = useState("");
//     const [directoryData, setDirectoryData] = useState([]);
//     const [allFilesData, setAllFilesData] = useState([]);
//     const [currentDataSource, setCurrentDataSource] = useState('all');
//     const [allColumns, setAllColumns] = useState([]);
//     const [visibleColumns, setVisibleColumns] = useState([]);
//     const [currentPage, setCurrentPage] = useState(0);
//     const filesPerPage = 50;
//     const [totalFileCount, setTotalFileCount] = useState(0);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
//     const [isDataLoading, setIsDataLoading] = useState(false);
//     const [dataError, setDataError] = useState(null);
//     const isMounted = useRef(false);
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
//     const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//     const [tempFilters, setTempFilters] = useState({});
//     const [appliedFilters, setAppliedFilters] = useState({});
//     const [isSearchFocused, setIsSearchFocused] = useState(false);

//     // --- Fetching Logic (Using axios, No changes) ---
//     const fetchViewData = useCallback(async (endpoint, params = {}, signal) => {
//         setIsDataLoading(true);
//         setDataError(null);
//         let url = `/api${endpoint}`;
//         // Use axios config for params and signal
//         const config = {
//             params: params,
//             signal: signal,
//             withCredentials: true
//         };
//         try {
//              const response = await axios.get(url, config);
//              return response.data;
//         } catch (err) {
//              if (axios.isCancel(err)) {
//                   console.log(`Fetch aborted for ${endpoint}`);
//              } else {
//                   console.error(`Error fetching ${endpoint}:`, err);
//                   const errorMsg = err.response?.data?.error || err.message || `Failed to fetch data from ${endpoint}.`;
//                   setDataError(errorMsg);
//                   if (err.response?.status === 401 && handleLogout) {
//                      handleLogout(false);
//                   }
//              }
//              return null;
//         } finally {
//              // Check if the request was cancelled using axios way
//              if (!axios.isCancel(signal?.reason)) {
//                 setIsDataLoading(false);
//             }
//         }
//     }, [handleLogout]);

//     // Fetch columns Effect
//     useEffect(() => {
//         // fetch columns for filters
//         const fetchColumns = async () => {
//             try {
//                 const response = await axios.get('/api/knowledge_table_columns', { withCredentials: true });
//                 if (response.data && Array.isArray(response.data)) {
//                     const columnNames = response.data.map(row => {
//                         return row[0];
//                     });

//                     const filterableColumns = columnNames.filter(columnNames => !columnNames.startsWith('kn_') && columnNames !== 'id' && columnNames !== 'directory');
//                     setAllColumns(filterableColumns);
                        
//                     const defaultVisible = ['id', 'file_name', 'directory', 'topic_title', 'key_concepts'];
//                     const newVisible = defaultVisible.filter(c => filterableColumns.includes(c));
      
//                     if (visibleColumns.length > 0) {
//                         setVisibleColumns(prev => prev.filter(col => filterableColumns.includes(col)));
//                     } else {
//                         setVisibleColumns(newVisible.length > 0 ? newVisible : filterableColumns.slice(0, 5));
//                     }
                        
//                 } else {
//                     console.error('Unexpected columns response format:', response.data);
//                     setAllColumns([]);
//                 }
//             } catch (error) {
//                 console.error('Error fetching columns:', error);
//                 setAllColumns([]);
//             }
//         };
//         fetchColumns();
//     }, []);

//     // Fetch All Files Effect
//     useEffect(() => {
//         isMounted.current = true;
//         let controller;
//         if (currentDataSource === 'all') {
//             controller = new AbortController();
//             const fetchAllFilesPage = async () => {
//                  const offset = currentPage * filesPerPage;
//                  const data = await fetchViewData('/all_files_sorted', { offset, limit: filesPerPage }, controller.signal);
//                  if (data && !controller.signal.aborted) {
//                      setAllFilesData(data.files || []);
//                      setTotalFileCount(data.totalCount || 0);
//                  }
//             };
//             fetchAllFilesPage();

//         } else if (currentDataSource === 'all' && Object.keys(appliedFilters).length > 0) {

//         }
//         return () => { if (controller) controller.abort(); isMounted.current = false; };
//      // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [currentPage, currentDataSource, appliedFilters]);

//     // Fetch Directory Data Effect
//     useEffect(() => {
//         if (!isMounted.current && currentDataSource !== 'all') return;
//         let controller;
//         if (selectedDirectory) {
//             controller = new AbortController();
//             const fetchDirectory = async () => {
//                 setIsDataLoading(true);
//                 setCurrentDataSource('directory');
//                 setCurrentPage(0);
//                 setSearchTerm("");
//                 setAppliedFilters({});
//                 const data = await fetchViewData('/get_directory_data', { directory: selectedDirectory }, controller.signal);
//                 if (data && !controller.signal.aborted) {
//                     setDirectoryData(data.files || []);
//                     setTotalFileCount((data.files || []).length);
//                 } else if (!controller.signal?.aborted) {
//                     setDirectoryData([]); setTotalFileCount(0);
//                 }
//             };
//             fetchDirectory();
//         } else {
//             if (currentDataSource === 'directory') {
//                  setDirectoryData([]);
//                  setSearchTerm("");
//                  setCurrentDataSource('all');
//                  if (currentPage !== 0) { setCurrentPage(0); }
//                  else { /* Manually trigger page 0 fetch if needed */
//                     const tempController = new AbortController();
//                     fetchViewData('/all_files_sorted', { offset: 0, limit: filesPerPage }, tempController.signal)
//                          .then(data => { /* update state */ });
//                  }
//             }
//         }
//         return () => { if (controller) controller.abort(); };
//      // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [selectedDirectory]); // Simplified dependencies

//     // --- Handlers (No changes needed) ---
//     const handleFileSelection = (file) => { setSelectedFile(file); setIsDetailModalOpen(true); };
//     const closeDetailModal = () => { setIsDetailModalOpen(false); };
//     const handleToggleColumn = (column) => { setVisibleColumns(prev => prev.includes(column) ? prev.filter(col => col !== column) : [...prev, column]); };
//     const handlePreviousPage = () => { setCurrentPage(prev => Math.max(0, prev - 1)); };
//     const handleNextPage = () => { const maxPage = Math.ceil(totalFileCount / filesPerPage) - 1; setCurrentPage(prev => Math.min(maxPage, prev + 1)); };
    
//     const performSearch = useCallback(async (currentSearchTerm, currentAppliedFilters) => {
//         let controller = new AbortController();
//         setIsDetailModalOpen(false);
//         setSelectedFile(null);

//         if (currentSearchTerm.trim() || Object.keys(currentAppliedFilters).length > 0) {
//             setCurrentDataSource('search');
//             setCurrentPage(0);

//             const searchParams = {
//                 searchTerm: currentSearchTerm.trim(),
//                 filters: JSON.stringify(currentAppliedFilters),
//                 selectedDirectory: selectedDirectory ? selectedDirectory : null
//             };
//             const data = await fetchViewData('/search_files', searchParams, controller.signal);
//             if (data && !controller.signal.aborted) {
//                 setAllFilesData(data.results || []);
//                 setTotalFileCount(data.fileCount || 0);
//                 setDirectoryData([]);
//             } else if (!controller.signal?.aborted) {
//                 setAllFilesData([]); setTotalFileCount(0);
//             }
//         } else {
//             if (selectedDirectory) {
//                 setCurrentDataSource('directory');
//             } else {
//                 setCurrentDataSource('all');
//             }
//             setAppliedFilters({});
//             if (currentPage !== 0) { setCurrentPage(0); }
//             // else the useEffect for 'all' dataSource should kick in.
//         }
//         return () => { controller.abort(); };
//     }, [selectedDirectory, allColumns.length, visibleColumns.length, fetchViewData]);
    
//     const handleSearchSubmit = (e) => {
//         e.preventDefault();
//         performSearch(searchTerm, appliedFilters);
//     };

//     const handleOpenFilterModal = () => {
//         setTempFilters({ ...appliedFilters });
//         setIsFilterModalOpen(true);
//     };

//     const handleFilterChange = (column, value) => {
//         setTempFilters(prev => ({ ...prev, [column]: value }));
//     };

//     const handleApplyFiltersFromModal = () => {
//         const newAppliedFilters = { ...tempFilters };
//         for (const key in newAppliedFilters) {
//             if (newAppliedFilters[key] === '' || newAppliedFilters[key] === null) {
//                 delete newAppliedFilters[key];
//             }
//         }
//         setAppliedFilters(newAppliedFilters);
//         setIsFilterModalOpen(false);
//         performSearch(searchTerm, newAppliedFilters);
//     };

//     const handleClearAllFiltersInModal = () => {
//         setTempFilters({});
//         setAppliedFilters({});
//         setIsFilterModalOpen(false);
//         performSearch(searchTerm, {});
//     };

//     const handleClearAppliedFilterTag = (filterKey) => {
//         const newAppliedFilters = { ...appliedFilters };
//         delete newAppliedFilters[filterKey];
//         setAppliedFilters(newAppliedFilters);
//         performSearch(searchTerm, newAppliedFilters);
//     };

//     // --- Data Selection for Display ---
//     const filesToDisplay = (currentDataSource === 'directory' && Object.keys(appliedFilters).length === 0) // Show directoryData only if no filters applied
//         ? directoryData
//         : (currentDataSource === 'search' || currentDataSource === 'all' || Object.keys(appliedFilters).length > 0)
//         ? allFilesData
//         : [];
//     const showPagination = (currentDataSource === 'all' || currentDataSource === 'search') && totalFileCount > filesPerPage;


//     // --- Render Logic (No changes needed) ---
//     return (
//         <div className="data-view-page">
//              <h2>Data View</h2>
//              <p>Explore and view details of the processed knowledge files.</p>

//             {/* Controls */}
//             <div className="data-view-controls">
//                     <div className="control-group">
//                         <label htmlFor="dataViewDirSelect">Select Directory:</label>
//                         <select id="dataViewDirSelect" value={selectedDirectory} onChange={(e) => setSelectedDirectory(e.target.value)} disabled={isDataLoading}>
//                         <option value="">-- All Files --</option>
//                         {directories.map(dir => <option key={dir} value={dir}>{dir}</option>)}
//                     </select>
//                 </div>
//                 <div className="search-form-wrapper">
//                     <form onSubmit={handleSearchSubmit} className="control-group search-group">
//                     {/* style={isSearchFocused ? { position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10, background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' } : {}}> */}
//                         <label htmlFor="dataViewSearch">Search Files:</label>
//                          <div className="search-textarea-wrapper" style={{ position: 'relative', flex: 1 }}>
//                             <textarea
//                                 className={`search-textarea${isSearchFocused ? ' expanded' : ''}`}
//                                 id="dataViewSearch"
//                                 placeholder="LLM query..."
//                                 value={searchTerm}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 disabled={isDataLoading}
//                                 style={{
//                                     resize: isSearchFocused ? 'both' : 'none',
//                                     overflow: 'auto',
//                                     minHeight: '40px',
//                                     maxHeight: '200px',
//                                     width: '100%',
//                                 }}
//                                 onFocus={() => setIsSearchFocused(true)}
//                                 onBlur={(e) => { setIsSearchFocused(false); e.target.style.height = '30px'; e.target.style.width = '100%'; }}
//                             />
//                         </div>
//                         <button type="submit" disabled={isDataLoading || !searchTerm.trim()}>Search</button>
//                     </form>
//                 </div>
//                 <div className="control-group">
//                     <button onClick={handleOpenFilterModal} disabled={isDataLoading}>
//                         Filters ({Object.keys(appliedFilters).length})
//                     </button>
//                     <button onClick={() => setIsColumnModalOpen(true)} disabled={isDataLoading || allColumns.length === 0}>
//                         Select Columns
//                     </button>
//                     </div>
//             </div>

//             {/* Display Applied Filters */}
//             {Object.keys(appliedFilters).length > 0 && (
//                 <div className="applied-filters-display" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
//                     <strong style={{marginRight: '5px'}}>Active Filters:</strong>
//                     {Object.entries(appliedFilters).map(([key, value]) => (
//                         <span key={key} className="filter-tag" style={{ backgroundColor: '#e0e0e0', padding: '3px 8px', borderRadius: '3px', fontSize: '0.9em' }}>
//                             {key}: "{value}"
//                             <button onClick={() => handleClearAppliedFilterTag(key)} style={{ marginLeft: '5px', border: 'none', background: 'transparent', color: 'red', cursor: 'pointer', fontWeight: 'bold' }}>x</button>
//                         </span>
//                     ))}
//                     <button
//                         onClick={() => { setAppliedFilters({}); performSearch(searchTerm, {}); }}
//                         style={{ marginLeft: 'auto', padding: '3px 8px', fontSize: '0.9em' }}
//                         className="secondary"
//                     >
//                         Clear All Applied Filters
//                     </button>
//                 </div>
//             )}

//              {/* Status Indicators */}
//              {dataError && <div className="error" style={{ marginTop: '15px' }}>{dataError}</div>}
//              {isDataLoading && <div className="loading" style={{ marginTop: '15px', textAlign:'center' }}>Loading data...</div>}

//              {/* File Table */}
//              {!isDataLoading && (
//                 <div className="data-table-container">
//                      {/* Dynamic Header Text */}
//                     {currentDataSource === 'directory' && <p>Displaying {filesToDisplay.length} files for directory: <strong>{selectedDirectory}</strong></p>}
//                     {currentDataSource === 'search' && <p>Displaying {filesToDisplay.length} search results for: "{searchTerm}"</p>}
//                     {currentDataSource === 'all' && <p>Displaying files {(currentPage * filesPerPage) + 1} - {Math.min(totalFileCount, (currentPage + 1) * filesPerPage)} of {totalFileCount} (All Files)</p>}

//                     {/* Table Content */}
//                     {filesToDisplay.length > 0 ? (
//                         <table className="data-view-table">
//                              <thead>
//                                 <tr>
//                                     {visibleColumns.filter(vc => allColumns.includes(vc)).map(col => <th key={col}>{col}</th>)}
//                                 </tr>
//                             </thead>
//                              <tbody>
//                                 {filesToDisplay.map((file) => (
//                                     <tr
//                                         key={file.id}
//                                         onClick={() => handleFileSelection(file)}
//                                         className={isDetailModalOpen && selectedFile?.id === file.id ? 'selected-row' : ''}
//                                         style={{ cursor: 'pointer' }}
//                                         title={`Click to view details for ${file.file_name || file.id}`}
//                                     >
//                                         {visibleColumns.filter(vc => allColumns.includes(vc)).map(col => (
//                                             <td key={col} title={typeof file[col] === 'object' ? JSON.stringify(file[col]) : String(file[col] ?? '')}>
//                                                 {typeof file[col] === 'object' && file[col] !== null
//                                                     ? JSON.stringify(file[col]).substring(0, 100) + (JSON.stringify(file[col])?.length > 100 ? '...' : '')
//                                                     : String(file[col] ?? '').substring(0, 150) + (String(file[col] ?? '').length > 150 ? '...' : '')
//                                                 }
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     ) : (
//                         !isDataLoading && <p style={{ textAlign: 'center', marginTop: '20px', fontStyle: 'italic', color: '#666' }}>No files found for the current selection.</p>
//                     )}

//                      {/* Pagination */}
//                      {showPagination && (
//                          <div className="pagination-controls">
//                             <button onClick={handlePreviousPage} disabled={currentPage === 0 || isDataLoading}>Previous</button>
//                             <span> Page {currentPage + 1} of {Math.ceil(totalFileCount / filesPerPage)} </span>
//                             <button onClick={handleNextPage} disabled={currentPage >= Math.ceil(totalFileCount / filesPerPage) - 1 || isDataLoading}>Next</button>
//                          </div>
//                      )}
//                 </div>
//              )}

//             {/* Modals */}
//             <ColumnSelectionModal
//                 visible={isColumnModalOpen}
//                 onClose={() => setIsColumnModalOpen(false)}
//                 onToggleColumn={handleToggleColumn}
//                 visibleColumns={visibleColumns}
//                 allColumns={allColumns}
//             />
//              {/* Use the updated FileDetailModal component */}
//              <FileDetailModal
//                 isOpen={isDetailModalOpen}
//                 onClose={closeDetailModal}
//                 fileData={selectedFile}
//                 allColumns={allColumns}
//             />
            
//             <FilterModal
//                 isOpen={isFilterModalOpen}
//                 onClose={() => setIsFilterModalOpen(false)}
//                 allColumns={allColumns}
//                 currentFilters={tempFilters}
//                 onApplyFilters={handleApplyFiltersFromModal}
//                 onFilterChange={handleFilterChange}
//                 onClearAllFilters={handleClearAllFiltersInModal}
//             />
//         </div>
//     );
// };

// export default DataView;

// frontend/src/DataView.js
import React, { useEffect, useState, useCallback } from "react";
import axios from 'axios';
import Modal from 'react-modal';

// Import the dedicated stylesheet for this component
import './DataView.css'; 
import FilterModal from './FilterModal.js';

// Set the root element for accessibility
Modal.setAppElement('#root');

// --- Column Selection Modal ---
const ColumnSelectionModal = ({ visible, onClose, onToggleColumn, visibleColumns = [], allColumns = [] }) => {
    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            contentLabel="Select Columns"
            className="dataview-modal-content column-select-modal"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
        >
            <div className="modal-header">
                <h3>Select Columns to Display</h3>
            </div>
            <div className="modal-content">
                <div className="column-list">
                    {allColumns.map(col => (
                        <div key={col} className="column-item">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={visibleColumns.includes(col)}
                                    onChange={() => onToggleColumn(col)}
                                />
                                {col}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
             <div className="modal-footer modal-button-group">
                <button onClick={onClose} className="modal-close-button">Close</button>
            </div>
        </Modal>
    );
};

// --- File Detail Modal ---
const FileDetailModal = ({ isOpen, onClose, fileData, allColumns = [] }) => {
    const [activeTab, setActiveTab] = useState('details');
    const [selectedKnColumn, setSelectedKnColumn] = useState('');
    const [statements, setStatements] = useState([]);
    const [knColumns, setKnColumns] = useState([]);
    const [parsingError, setParsingError] = useState('');

    useEffect(() => {
        if (fileData) {
            const availableKnCols = allColumns.filter(col => col.startsWith('kn_') && fileData[col] != null);
            setKnColumns(availableKnCols);
            setSelectedKnColumn(availableKnCols.length > 0 ? availableKnCols[0] : '');
            setActiveTab('details');
            setParsingError('');
        }
    }, [fileData, allColumns]);

    const generateStatementsFromKnData = useCallback((knDataRaw) => {
        setParsingError('');
        if (!knDataRaw) return [];
        let jsonData = null;
        try {
            jsonData = typeof knDataRaw === 'string' ? JSON.parse(knDataRaw) : knDataRaw;
        } catch (error) {
            setParsingError(`Error parsing data in '${selectedKnColumn}'. Invalid JSON.`);
            return [];
        }
        if (!jsonData) return [];
        
        const dataArray = Array.isArray(jsonData) ? jsonData : [jsonData];
        const generatedStatements = [];
        dataArray.forEach((item, index) => {
            if (item && item.node_1 && item.node_2 && item.edge) {
                generatedStatements.push({ id: `${selectedKnColumn}-${index}`, text: `${item.node_1} ${item.edge} ${item.node_2}` });
            }
        });
        return generatedStatements;
    }, [selectedKnColumn]);

    useEffect(() => {
        if (fileData && selectedKnColumn) {
            setStatements(generateStatementsFromKnData(fileData[selectedKnColumn]));
        } else {
            setStatements([]);
        }
    }, [fileData, selectedKnColumn, generateStatementsFromKnData]);

    if (!fileData) return null;

    const detailColumns = allColumns.filter(col => !col.startsWith('kn_'));

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="File Details" className="dataview-modal-content file-detail-modal" overlayClassName="modal-overlay" ariaHideApp={false} >
            <div className="modal-header">
                <span>Details for: {fileData.file_name || `ID: ${fileData.id}`}</span>
                <button onClick={onClose} className="modal-close-button">Close</button>
            </div>
            <div className="modal-tabs">
                <button className={activeTab === 'details' ? 'active' : ''} onClick={() => setActiveTab('details')}>Details</button>
                {knColumns.length > 0 && ( <button className={activeTab === 'statements' ? 'active' : ''} onClick={() => setActiveTab('statements')}>Statements</button> )}
            </div>
            <div className="modal-content">
                {activeTab === 'details' && (
                    <div className="details-grid">
                        {detailColumns.map(col => (
                            <React.Fragment key={col}>
                                <div className="detail-label">{col}:</div>
                                <div className="detail-value">
                                    {typeof fileData[col] === 'object' && fileData[col] !== null ? ( <pre>{JSON.stringify(fileData[col], null, 2)}</pre> ) : ( <div>{String(fileData[col] ?? 'N/A')}</div> )}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                )}
                {activeTab === 'statements' && (
                    <div className="statements-tab">
                        {knColumns.length > 0 ? (
                            <>
                                <div className="source-select-container">
                                    <label htmlFor="knColumnSelect">Select Source:</label>
                                    <select id="knColumnSelect" value={selectedKnColumn} onChange={(e) => setSelectedKnColumn(e.target.value)}>
                                        {knColumns.map(col => <option key={col} value={col}>{col}</option>)}
                                    </select>
                                </div>
                                {parsingError && <div className="error">{parsingError}</div>}
                                {statements.length > 0 ? (
                                    <ol className="statement-list">
                                        {statements.map((stmt, index) => <li key={stmt.id || index} className="statement-item">{stmt.text}</li>)}
                                    </ol>
                                ) : ( !parsingError && <p>No statements found for '{selectedKnColumn}'.</p> )}
                                <p className="statement-count">Displaying {statements.length} statements from: <strong>{selectedKnColumn}</strong></p>
                            </>
                        ) : ( <p>No knowledge columns (starting with 'kn_') found.</p> )}
                    </div>
                )}
            </div>
        </Modal>
    );
};

// --- Main DataView Component ---
const DataView = ({ directories = [], handleLogout }) => {
    const [selectedDirectory, setSelectedDirectory] = useState("");
    const [allFilesData, setAllFilesData] = useState([]);
    const [allColumns, setAllColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const filesPerPage = 50;
    const [totalFileCount, setTotalFileCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [dataError, setDataError] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [tempFilters, setTempFilters] = useState({});
    const [appliedFilters, setAppliedFilters] = useState({});

    const fetchViewData = useCallback(async (endpoint, params = {}, signal) => {
        setIsDataLoading(true); setDataError(null);
        try {
             const response = await axios.get(`/api${endpoint}`, { params, signal, withCredentials: true });
             return response.data;
        } catch (err) {
             if (!axios.isCancel(err)) {
                  const errorMsg = err.response?.data?.error || err.message || `Failed to fetch data.`;
                  setDataError(errorMsg);
                  if (err.response?.status === 401 && handleLogout) handleLogout(false);
             }
             return null;
        } finally {
             if (!signal?.aborted) setIsDataLoading(false);
        }
    }, [handleLogout]);

    useEffect(() => {
        const controller = new AbortController();
        fetchViewData('/knowledge_table_columns', {}, controller.signal).then(data => {
            if(data && !controller.signal.aborted) {
                const columnNames = data.map(row => row[0]);
                setAllColumns(columnNames);
                const defaultVisible = ['id', 'file_name', 'directory', 'topic_title', 'key_concepts'];
                setVisibleColumns(defaultVisible.filter(c => columnNames.includes(c)));
            }
        });
        return () => controller.abort();
    }, [fetchViewData]);

    useEffect(() => {
        const controller = new AbortController();
        const offset = currentPage * filesPerPage;
        
        const isSearchingOrFiltering = searchTerm.trim() || Object.keys(appliedFilters).length > 0 || selectedDirectory;

        if (isSearchingOrFiltering) {
            const searchParams = {
                searchTerm: searchTerm.trim(),
                filters: JSON.stringify(appliedFilters),
                selectedDirectory: selectedDirectory || null,
                limit: filesPerPage,
                offset: offset,
            };
            fetchViewData('/search_files', searchParams, controller.signal).then(data => {
                if (data && !controller.signal.aborted) {
                    setAllFilesData(data.results || []);
                    setTotalFileCount(data.totalCount || 0);
                }
            });
        } else {
            const params = { limit: filesPerPage, offset };
            fetchViewData('/all_files_sorted', params, controller.signal).then(data => {
                if (data && !controller.signal.aborted) {
                    setAllFilesData(data.files || []);
                    setTotalFileCount(data.totalCount || 0);
                }
            });
        }
        return () => controller.abort();
    }, [currentPage, selectedDirectory, appliedFilters, searchTerm, fetchViewData]);

    const handleFileSelection = (file) => { setSelectedFile(file); setIsDetailModalOpen(true); };
    const handleToggleColumn = (column) => setVisibleColumns(prev => prev.includes(column) ? prev.filter(c => c !== column) : [...prev, column]);
    const handlePreviousPage = () => setCurrentPage(prev => Math.max(0, prev - 1));
    const handleNextPage = () => setCurrentPage(prev => (prev + 1) * filesPerPage < totalFileCount ? prev + 1 : prev);

    const handleSearchSubmit = (e) => { e.preventDefault(); setCurrentPage(0); };
    const handleDirectoryChange = (e) => { setSelectedDirectory(e.target.value); setCurrentPage(0); };
    
    const handleApplyFilters = () => {
        const newFilters = { ...tempFilters };
        Object.keys(newFilters).forEach(key => (newFilters[key] === '') && delete newFilters[key]);
        setAppliedFilters(newFilters);
        setIsFilterModalOpen(false);
        setCurrentPage(0);
    };
    
    const handleClearAllFilters = () => {
        setAppliedFilters({});
        setTempFilters({});
        setIsFilterModalOpen(false);
        setCurrentPage(0);
    };
    
    const handleClearFilterTag = (filterKey) => {
        const newFilters = { ...appliedFilters }; delete newFilters[filterKey];
        setAppliedFilters(newFilters);
        setCurrentPage(0);
    };

    return (
        <div className="data-view-page">
            <h2>Data View</h2>
            <p>Explore, search, and view details of the processed knowledge files.</p>
            
            <div className="data-view-controls">
                <div className="control-group">
                    <label htmlFor="dataViewDirSelect">Filter by Directory:</label>
                    <select id="dataViewDirSelect" value={selectedDirectory} onChange={handleDirectoryChange} disabled={isDataLoading}>
                        <option value="">-- All Directories --</option>
                        {directories.map(dir => <option key={dir} value={dir}>{dir}</option>)}
                    </select>
                </div>
                <div className="search-form-wrapper">
                    <form onSubmit={handleSearchSubmit} className="search-group">
                        <textarea className="search-textarea" id="dataViewSearch" placeholder="LLM query or keywords..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} disabled={isDataLoading} />
                        <button type="submit" disabled={isDataLoading}>Search</button>
                    </form>
                </div>
                <div className="control-group button-group">
                    <button onClick={() => { setTempFilters({...appliedFilters}); setIsFilterModalOpen(true);}} disabled={isDataLoading} className="secondary">Filters ({Object.keys(appliedFilters).length})</button>
                    <button onClick={() => setIsColumnModalOpen(true)} disabled={isDataLoading || allColumns.length === 0} className="secondary">Columns</button>
                </div>
            </div>

            {Object.keys(appliedFilters).length > 0 && (
                <div className="applied-filters-display">
                    <strong>Active Filters:</strong>
                    {Object.entries(appliedFilters).map(([key, value]) => (
                        <span key={key} className="filter-tag">{key}: "{value}"<button onClick={() => handleClearFilterTag(key)} title={`Remove filter for ${key}`} className="filter-tag-remove">×</button></span>
                    ))}
                    <button onClick={handleClearAllFilters} className="clear-all-filters-button">Clear All</button>
                </div>
            )}

            {dataError && <div className="error">{dataError}</div>}
            {isDataLoading && <div className="loading">Loading data...</div>}
            
            {!isDataLoading && <div className="data-table-container">
                {allFilesData.length > 0 ? (
                    <table className="data-view-table">
                        <thead><tr>{visibleColumns.map(col => <th key={col}>{col}</th>)}</tr></thead>
                        <tbody>
                            {allFilesData.map((file) => (
                                <tr key={file.id} onClick={() => handleFileSelection(file)} className={selectedFile?.id === file.id ? 'selected-row' : ''} style={{ cursor: 'pointer' }}>
                                    {visibleColumns.map(col => (<td key={col} title={String(file[col] ?? '')}>{String(file[col] ?? '')}</td>))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (<p style={{ textAlign: 'center', padding: '40px' }}>No files found for the current selection.</p>)}
            </div>}

            {totalFileCount > filesPerPage && !isDataLoading && (
                <div className="pagination-controls">
                    <button onClick={handlePreviousPage} disabled={currentPage === 0}>Previous</button>
                    <span>Page {currentPage + 1} of {Math.ceil(totalFileCount / filesPerPage)}</span>
                    <button onClick={handleNextPage} disabled={(currentPage + 1) * filesPerPage >= totalFileCount}>Next</button>
                </div>
            )}

            <ColumnSelectionModal visible={isColumnModalOpen} onClose={() => setIsColumnModalOpen(false)} onToggleColumn={handleToggleColumn} visibleColumns={visibleColumns} allColumns={allColumns.filter(c => !c.startsWith('kn_'))} />
            <FileDetailModal isOpen={isDetailModalOpen} onClose={() => { setSelectedFile(null); setIsDetailModalOpen(false); }} fileData={selectedFile} allColumns={allColumns} />
            <FilterModal isOpen={isFilterModalOpen} onClose={() => setIsFilterModalOpen(false)} allColumns={allColumns.filter(c => !c.startsWith('kn_'))} currentFilters={tempFilters} onApplyFilters={handleApplyFilters} onFilterChange={(col, val) => setTempFilters(p => ({...p, [col]: val}))} onClearAllFilters={handleClearAllFilters} />
        </div>
    );
};

export default DataView;